export const STATUS_OPTIONS = {
  all: { key: 'all', title: 'All statuses' },
  Pending: { key: 'Pending', title: 'Pending' },
  InProgress: { key: 'InProgress', title: 'In progress' },
  Completed: { key: 'Completed', title: 'Completed' },
} as const;

export const SORT_OPTIONS = ['createdAt:asc', 'createdAt:desc', 'lastUpdatedAt:asc', 'lastUpdatedAt:desc'] as const;
export type SortOption = (typeof SORT_OPTIONS)[number];
